<template>
    <div class="m-promoPreviewSmallDetails">
        <p class="typo typo--name">
            {{ name }}
            <span v-if="retailer_info">({{ retailer_info }})</span>
        </p>
        <p class="typo typo--secondary">{{ promoType }}</p>
        <p class="typo typo--secondary">
            Od
            <time datetime
                ><strong
                    >{{ $moment(startAt).format('DD-MM-YYYY') }}&nbsp;</strong
                >{{ $moment(startAt).format('HH:mm') }}</time
            >
            do
            <time datetime
                ><strong
                    >{{ $moment(finishAt).format('DD-MM-YYYY') }}&nbsp;</strong
                >{{ $moment(finishAt).format('HH:mm') }}</time
            >
        </p>

        <div class="m-promoPreviewSmallDetails__bottomBelt">
            <div class="m-promoPreviewSmallDetails__producerStatsWrapper">
                <div
                    v-if="company"
                    class="tr-brand  mt-0"
                    :style="
                        `background-image: url(${company &&
                            company.logo &&
                            company.logo.urls.small})`
                    "
                ></div>
                <div class="m-promoPreviewSmallDetails__stats">
                    <div
                        v-if="showState"
                        class="m-promoPreviewSmallDetails__state"
                    >
                        <span
                            v-if="state === 'cancelled'"
                            class="status is-canceled"
                        >
                            <a-icon icon="Info" />
                            <span>Anulowana</span>
                        </span>
                        <span
                            v-if="state === 'finished'"
                            class="status is-finished"
                        >
                            <a-icon icon="Info" />
                            <span>Zakończona</span>
                        </span>
                    </div>
                    <div
                        v-if="showProgress"
                        class="text-primary font-weight-bold m-promoPreviewSmallDetails__progress"
                    >
                        <span class="mb-1">
                            <strong>{{ daysLeft.countText }}</strong> pozostało
                            <span class="nowrap">
                                <span
                                    class="text-primary"
                                    v-html="
                                        $options.filters.plurals(
                                            daysLeft.diff,
                                            'dzień',
                                            'dni',
                                            undefined,
                                            true,
                                            '#B92879'
                                        )
                                    "
                                ></span>
                                <template v-if="!daysLeft.promotionIncoming">
                                    <strong
                                        >&nbsp;z&nbsp;
                                        <span class="text-secondary">
                                            {{ durationDays }}</span
                                        ></strong
                                    >
                                </template>
                            </span>
                        </span>
                        <div
                            class="progress"
                            :class="{
                                'progress--incoming': daysLeft.promotionIncoming
                            }"
                        >
                            <div
                                role="progressbar"
                                class="progress-bar"
                                :style="`width: ${progressWidth}%`"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="m-promoPreviewSmallDetails__prize text-primary font-weight-bold"
                        v-if="showPrizeAmount"
                    >
                        <div>
                            Nagroda:
                            <span
                                class="text-secondary m-promoPreviewSmallDetails__prizeAmount"
                                >{{ promotionAward | currency }}</span
                            >
                        </div>
                    </div>
                    <div
                        v-if="showNetReturn"
                        class="m-promoPreviewSmallDetails__netRefund font-weight-bold"
                    >
                        <span
                            class="text-primary m-promoPreviewSmallDetails__netRefundTitle "
                            >Zwrot netto</span
                        >
                        <span
                            class="text-secondary ml-1 m-promoPreviewSmallDetails__netRefundAmount"
                            >{{ totalRefund }}</span
                        >
                    </div>
                    <div
                        v-if="showShopsCounter"
                        class="m-promoPreviewSmallDetails__shopsAvailability font-weight-bold text-primary"
                    >
                        {{ shopsCounterTitle }} w
                        <strong class="text-secondary px-1"
                            >{{
                                subscriptions.filter(
                                    el => el.state === shopsCounterKeyword
                                ).length
                            }}
                        </strong>
                        z
                        <span
                            class="m-promoPreviewSmallDetails__shopsAvailabilityCounter pl-1"
                            v-html="
                                $options.filters.plurals(
                                    subscriptions.length,
                                    'sklepu',
                                    'sklepów',
                                    undefined,
                                    true,
                                    '#B92879'
                                )
                            "
                        ></span>
                    </div>
                </div>
            </div>
            <div v-if="showButtons">
                <div
                    @click.stop.prevent
                    v-if="!selectionConflict"
                    v-tooltip="{
                        content: tooltipContent
                    }"
                >
                    <the-btn
                        :disabled="promoCheckboxDisabled"
                        @click.native.stop.prevent="
                            () => !promoCheckboxDisabled && onPromotionSelect()
                        "
                        btnClass=""
                        :text="
                            selected
                                ? 'Dodano do akceptacji'
                                : 'Dodaj do akceptacji'
                        "
                        :class="
                            `btn-custom-gray m-promoPreviewSmallDetails__action ${
                                selected ? 'active' : ''
                            }`
                        "
                        :icon="selected ? 'Approval' : 'Plus'"
                    ></the-btn>
                </div>
                <div
                    v-else
                    v-tooltip="{
                        content: tooltipContent
                    }"
                    @click.stop.prevent="onPromotionSelect"
                    class="m-promoPreviewSmallDetails__action m-promoPreviewSmallDetails__action--error"
                >
                    {{ selectionConflict }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'PromotionPreviewSmallDetails',
    props: {
        type: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        id: {
            type: Number,
            default: 0
        },
        startAt: {
            type: String,
            default: ''
        },
        finishAt: {
            type: String,
            default: ''
        },
        state: {
            type: String,
            default: ''
        },
        company: {
            type: Object,
            default: () => {}
        },
        totalRefundAmount: {
            type: Array,
            default: () => []
        },
        subscriptions: {
            type: Array,
            default: () => []
        },
        selectionConflict: {
            type: [String, null],
            default: null
        },
        previewType: {
            type: String,
            default: ''
        },
        prizeAmount: {
            type: String,
            default: ''
        },
        salesTargetThresholds: {
            type: Array,
            default: () => []
        },
        retailer_info: {
            type: String,
            default: ''
        }
    },
    computed: {
        promotionAward() {
            let promotionAward = this.prizeAmount

            if (this.salesTargetThresholds.length > 0) {
                const prices = this.salesTargetThresholds.map(
                    e => +e.prize_amount
                )
                const largestPrice = prices
                    .sort((a, b) => {
                        return a - b
                    })
                    .pop()
                promotionAward = largestPrice
            }

            return promotionAward
        },
        allSubsRejected() {
            // eslint-disable-next-line
            const rejected = this.subscriptions.filter(el => {
                const updatedDate = new Date(el.updated_at)

                return (
                    el.state === 'interrupted' &&
                    moment().isSame(updatedDate, 'day')
                )
            })
            return rejected.length === this.subscriptions.length
        },
        moreThanOneButNotAllSubsRejected() {
            // eslint-disable-next-line
            const rejected = this.subscriptions.filter(
                el =>
                    el.state === 'interrupted' &&
                    el.updated_at &&
                    el.updated_at.slice(0, 10) ===
                        this.$moment().format('DD-MM-YYYY')
            )
            return rejected.length > 0
        },
        tooltipContent() {
            let content = null
            if (
                this.subscriptions &&
                this.subscriptions.length > 0 &&
                this.subscriptions[0].company_merchant_status === 'inactive'
            ) {
                content =
                    'Aby móc zaakceptować tą promocję, aktywuj usługę producenta. Kliknij w promocję po więcej szczegółów.'
            }
            if (this.moreThanOneButNotAllSubsRejected) {
                content =
                    'Promocja została anulowana w wybranych sklepach. Ponowna aktywacja promocji w tych sklepach będzie możliwa jutro.'
            }
            if (this.allSubsRejected) {
                content =
                    'Promocja została anulowana. Ponowna akceptacja będzie możliwa jutro'
            }
            if (
                this.subscriptions &&
                this.subscriptions.length > 0 &&
                this.subscriptions.find(el => el.state === 'incompatible')
            ) {
                content =
                    'Stanowiska kasowe w sklepie nie obsługują tego typu promocji. Aby aktywować promocję, zaktualizuj kasę lub system sprzedażowy do najnowszej wersji oprogramowania. Zadzwoń, jeśli potrzebujesz wsparcia 22&nbsp;123&nbsp;84&nbsp;00.'
            }

            return content
        },
        promoCheckboxDisabled() {
            return !this.subscriptions.find(el => el.state === 'available')
        },
        durationDays() {
            const start = moment(this.startAt)
            const end = moment(this.finishAt)
            return end.diff(start, 'days')
        },
        daysLeft() {
            return this.$store.getters.getDaysLeft({
                start_at: this.startAt,
                finish_at: this.finishAt,
                state: this.state
            })
        },
        progressWidth() {
            const daysToShowProgress = 15
            const daysLeft = this.daysLeft.left
            if (daysLeft < daysToShowProgress) {
                return (
                    (100 / daysToShowProgress) * (daysToShowProgress - daysLeft)
                )
            } else {
                return 0
            }
        },
        showState() {
            return this.previewType === 'promo-finished'
        },
        showProgress() {
            return this.previewType === 'promo-yours'
        },
        showShopsCounter() {
            return this.previewType !== 'promo-finished'
        },
        showPrizeAmount() {
            return (
                this.type === 'Promo::SalesTarget' &&
                (this.prizeAmount || this.salesTargetThresholds.length > 0) &&
                (this.previewType === 'promo-list' ||
                    this.previewType === 'promo-later')
            )
        },
        showNetReturn() {
            return (
                this.type !== 'Promo::SalesTarget' &&
                (this.previewType === 'promo-list' ||
                    this.previewType === 'promo-later')
            )
        },
        showHeart() {
            return (
                this.previewType === 'promo-list' ||
                this.previewType === 'promo-later'
            )
        },
        showButtons() {
            return (
                this.previewType === 'promo-list' ||
                this.previewType === 'promo-later'
            )
        },
        shopsCounterKeyword() {
            let keyword = 'available'
            if (this.previewType === 'promo-yours') {
                keyword = 'accepted'
            }
            return keyword
        },
        shopsCounterTitle() {
            let title = 'Dostępna'
            if (this.previewType === 'promo-yours') {
                title = 'Aktywowana'
            }
            return title
        },
        selected() {
            return this.$store.getters.getSelectedPromotionBoolean(this.id)
        },
        promoType() {
            return this.$store.getters.getPromoTypeByValue(this.type)
        },
        totalRefund() {
            if (this.totalRefundAmount && !isNaN(this.totalRefundAmount[0])) {
                if (this.totalRefundAmount[1]) {
                    return `${(+this.totalRefundAmount[0]).toFixed(
                        2
                    )} - ${this.$options.filters.currency(
                        this.totalRefundAmount[1]
                    )}`
                } else {
                    return `${this.$options.filters.currency(
                        this.totalRefundAmount[0]
                    )}`
                }
            } else {
                return `${this.$options.filters.currency(0)}`
            }
        }
    },
    methods: {
        onPromotionSelect() {
            this.$store.dispatch('selectPromotion', {
                id: this.id,
                value: !this.selected
            })
            if (!this.selected) {
                this.$store.dispatch('setSelectAllPromotions', false)
            }
        }
    }
}
</script>
